import React from 'react';
import CustomSelect from './select';

const SupportPlaceCategories = ({
  isMobile,
  label,
  list,
  selectedCategory,
  onCategoryChange,
  showAllCategoriesButtonText,
}) => {
  const handleKeyDown = (event, key, value) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      onCategoryChange({ key, value });
    }
  };

  const categoryOptions = [
    ['showAll', showAllCategoriesButtonText || 'Alla stödställen och chattar'],
    ...Object.entries(list),
  ];

  return isMobile ? (
    <CustomSelect
      label={label}
      options={categoryOptions}
      selectedCategory={selectedCategory}
      onCategoryChange={onCategoryChange}
    />
  ) : (
    <div className="c-support-place__category-container">
      <label
        id="support-place-category-label"
        className="c-support-place__label"
      >
        {label}
      </label>
      <ul
        aria-labelledby="support-place-category-label"
        className="c-support-place__category-list"
      >
        {categoryOptions.map(([key, value]) => (
          <li key={key} className="c-support-place__category-item">
            <input
              tabIndex={-1}
              type="radio"
              id={`support-place-category-${key}`}
              name="supportPlaceCategories"
              value={value}
              className="c-support-place__category-input"
              checked={selectedCategory.key === key}
              onChange={() => onCategoryChange({ key, value })}
            />
            <label
              tabIndex={0}
              data-text={value}
              onKeyDown={(e) => handleKeyDown(e, key, value)}
              htmlFor={`support-place-category-${key}`}
              className="c-support-place__category-button"
            >
              <span>{value}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SupportPlaceCategories;
